import i18n from "@/i18n";

/*eslint-disable */
interface DateTimeDecoder {
  year: string | number;
  month: string | number;
  day: string | number;
  hour: string | number;
  minute: string | number;
  second: string | number;

  dmy: string;
  hm: string;
  hms: string;
  transliteDmy: string;
}
/*eslint-enable */

/**
 *
 * @param общие year, month, day, hour, minute, second
 * @param dmy DD.MM.YYYY
 * @param transliteDmy DD MM(i18n) YYYY
 * @param hm hh:mm
 * @param hms hh:mm:ss
 * @returns year, month, day, hour, minute, second, dmy, hm, transliteDmy, hms
 */
export function dateTimeDecoder(dateString: string | Date): DateTimeDecoder | null {
  if (!dateString) return null;

  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = date.getMonth() >= 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
  const day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
  const hour = date.getHours() > 9 ? date.getHours() : "0" + date.getHours();
  const minute = date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes();
  const second = date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds();

  const dmy = `${day}.${month}.${year}`;
  const transliteDmy = `${day} ${i18n.global.t(
    `date.months.${date.getMonth()}`
  )} ${year}`;

  const hm = `${hour}:${minute}`;
  const hms = `${hour}:${minute}:${second}`;

  return { year, month, day, hour, minute, second, dmy, hm, transliteDmy, hms };
}

// todo убрать заменить на dateTimeDecoder().dmy + " " + dateTimeDecoder().hm
export function getFullDateFormat(dateString: string | Date): string {
  if (!dateString) return "";

  const date = new Date(dateString);

  const year = date.getFullYear();
  const month = date.getMonth() >= 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
  const day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
  const hours = date.getHours() >= 9 ? date.getHours() : "0" + date.getHours();
  const minutes = date.getMinutes() >= 9 ? date.getMinutes() : "0" + date.getMinutes();

  const fullDate = `${day}.${month}.${year}`;
  const fullTime = `${hours}:${minutes}`;
  return fullDate + " " + fullTime;
}
// todo убрать заменить на dateTimeDecoder().transliteDmy + " " + dateTimeDecoder().hm
export function getFullNamesDateFormat(dateString: string | Date): string {
  if (!dateString) return "";
  const date = new Date(dateString);

  const day = date.getDate();
  const formattedDay = day >= 9 ? day : "0" + day;
  const month = date.getMonth();
  const formattedMonth = i18n.global.t(`date.months.${month}`);
  const year = date.getFullYear();
  const fullDate = `${formattedDay} ${formattedMonth} ${year}`; // Собираем дату в формате "DD.MM.YYYY"

  const hours = date.getHours() >= 9 ? date.getHours() : "0" + date.getHours();
  const minutes = date.getMinutes() >= 9 ? date.getMinutes() : "0" + date.getMinutes();
  const fullTime = `${hours}:${minutes}`;
  return fullDate + " " + fullTime;
}
// todo убрать заменить на dateTimeDecoder().hms || dateTimeDecoder().hm если !full
export function getFullTimeFormat(dateString: string | Date, full = false): string {
  if (dateString) {
    const date = new Date(dateString);

    const hours = date.getHours() > 9 ? date.getHours() : "0" + date.getHours();
    const minutes = date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes();
    const seconds = date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds();
    return full ? `${hours}:${minutes}:${seconds}` : `${hours}:${minutes}`;
  } else return "";
}
// todo убрать заменить на dateTimeDecoder().dmy
export function getDateFormat(dateString: string | Date): string {
  if (dateString) {
    const date = new Date(dateString);
    const day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
    const month =
      date.getMonth() >= 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  } else {
    return "";
  }
}

/**
 *
 * @param ms преобразует только из ms
 * @returns day, hour, minute;
 */
export function getMsTime(ms: number): {
  days: number;
  hours: number;
  minutes: number;
} {
  const seconds = Math.floor(ms / 1000);
  let minutes = Math.floor(seconds / 60);
  let hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  minutes = minutes - hours * 60;
  hours = hours - days * 24;

  return {
    days: days,
    hours: hours,
    minutes: minutes,
  };
}

/**
 * Рассчитывает разницу между двумя датами
 * @param date1 Первая дата (обычно более ранняя)
 * @param date2 Вторая дата (обычно более поздняя, по умолчанию текущая дата)
 * @returns Объект с разницей в годах, месяцах, днях, часах, минутах и секундах
 */
/**
 * Рассчитывает разницу между двумя датами со знаком
 * Положительные значения: date1 позже date2
 * Отрицательные значения: date1 раньше date2
 */
export function getSignedDateDifference(
  date1: Date,
  date2: Date = new Date()
): {
  year: number;
  month: number;
  day: number;
  hour: number;
  minute: number;
  second: number;
} {
  // Определяем направление разницы
  const isDate1Later = date1 > date2;
  const startDate = isDate1Later ? date2 : date1;
  const endDate = isDate1Later ? date1 : date2;

  // Вычисляем абсолютную разницу
  let years = endDate.getFullYear() - startDate.getFullYear();
  let months = endDate.getMonth() - startDate.getMonth();
  let days = endDate.getDate() - startDate.getDate();
  let hours = endDate.getHours() - startDate.getHours();
  let minutes = endDate.getMinutes() - startDate.getMinutes();
  let seconds = endDate.getSeconds() - startDate.getSeconds();

  // Корректировка отрицательных значений (в абсолютном исчислении)
  if (seconds < 0) {
    seconds += 60;
    minutes--;
  }

  if (minutes < 0) {
    minutes += 60;
    hours--;
  }

  if (hours < 0) {
    hours += 24;
    days--;
  }

  if (days < 0) {
    // Количество дней в предыдущем месяце
    const daysInPrevMonth = new Date(
      endDate.getFullYear(),
      endDate.getMonth(),
      0
    ).getDate();
    days += daysInPrevMonth;
    months--;
  }

  if (months < 0) {
    months += 12;
    years--;
  }

  // Применяем знак в зависимости от направления
  const sign = isDate1Later ? 1 : -1;

  return {
    year: years * sign,
    month: months * sign,
    day: days * sign,
    hour: hours * sign,
    minute: minutes * sign,
    second: seconds * sign,
  };
}

/**
 *
 * @param 1 - d1 > d2
 * @param -1- d1 < d2
 * @returns 0 - ==
 */
export function compareDates(date1: Date, date2 = new Date()): 1 | 0 | -1 {
  // Преобразуем в Date объекты, если переданы строки
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  // Сравниваем временные метки (миллисекунды с 1 января 1970)
  if (d1.getTime() === d2.getTime()) {
    return 0; // Даты равны
  }

  return d1.getTime() > d2.getTime() ? 1 : -1;
}

export const getPluralKey = (count: number): string => {
  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;

  if (lastDigit === 1 && lastTwoDigits !== 11) return "one";
  if (lastDigit >= 2 && lastDigit <= 4 && (lastTwoDigits < 10 || lastTwoDigits >= 20))
    return "few";
  return "many";
};
